import React, { useEffect, useState } from 'react';
import { getAdminOverview, AdminOverview } from '../../services/adminApi';

export const OverviewCards: React.FC = () => {
  const [data, setData] = useState<AdminOverview | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getAdminOverview()
      .then(setData)
      .catch(() => setError('Failed to load overview'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="admin-loading">Loading overview...</div>;
  if (error) return <div className="admin-error">{error}</div>;
  if (!data) return null;

  const cards = [
    { label: 'Total Students', value: data.total_students.toLocaleString() },
    { label: 'Active Today', value: data.active_today.toLocaleString() },
    { label: 'Active This Week', value: data.active_this_week.toLocaleString() },
    { label: 'Avg Accuracy (30d)', value: `${data.avg_accuracy_30d}%` },
    { label: 'Total Questions', value: data.total_questions.toLocaleString() },
  ];

  return (
    <div className="admin-cards-grid">
      {cards.map((c) => (
        <div key={c.label} className="admin-kpi-card">
          <div className="admin-kpi-value">{c.value}</div>
          <div className="admin-kpi-label">{c.label}</div>
        </div>
      ))}
    </div>
  );
};
